import type { Ref } from "react";

export const multipleRefs = <T>(...refs: (Ref<T> | undefined)[]) => {
  return (value: T) => {
    for (const ref of refs) {
      if (!ref) {
        continue;
      }

      if (typeof ref === "function") {
        ref(value);
      } else if (ref) {
        ref.current = value;
      }
    }
  };
};
